module.exports = __webpack_public_path__ + "static/img/IMG_20160101_162422.884e48e4.jpg";